export const getUpcomingEducation = (rows, todayKey) => {
  if (!Array.isArray(rows) || !todayKey) return [];
  return rows.filter((row) => {
    const date = typeof row?.edu_day === "string" ? row.edu_day.slice(0, 10) : "";
    return row?.status === "pending" && /^\d{4}-\d{2}-\d{2}$/.test(date) && date >= todayKey;
  });
};
